import { publicApiClient } from '@/lib/api/client';
import type {
  Event,
  AllEventsResponse
} from '@/features/events/types/types';

export const eventsService = {
  getAllEvents: async (): Promise<AllEventsResponse> => {
    try {
      const response = await publicApiClient.get<AllEventsResponse>('/api/public/v1/event/all');
      return response;
    } catch (error) {
      console.error('Error fetching events:', error);
      throw new Error('Failed to fetch events');
    }
  },

  getEventById: async (id: string): Promise<Event> => {
    try {
      const response = await publicApiClient.get<{ data: Event }>(`/api/public/v1/event/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event:', error);
      throw new Error('Failed to fetch event');
    }
  }
};
